import type { DokkanStats } from "@/lib/types";

export const SA_POWER_OPTIONS = [
	{ value: 5.7, label: "超極大 レベル20" },
	{ value: 4.25, label: "極大 レベル20" },
	{ value: 5.05, label: "超絶特大 レベル10" },
	{ value: 4.3, label: "超特大 レベル10" },
	{ value: 6.2, label: "超極大 レベル25(極限)" },
	{ value: 4.5, label: "極大 レベル25(極限)" },
	{ value: 6.3, label: "超絶特大 レベル15(極限)" },
	{ value: 5.3, label: "超特大 レベル15(極限)" },
] as const;

export const KI_BONUS_OPTIONS = [
	{ value: 2.0, label: "2.0 (気力24)" },
	{ value: 1.75, label: "1.75 (気力18)" },
	{ value: 1.5, label: "1.5 (フェス限・気力12)" },
	{ value: 1.6, label: "1.6 (フェス限・一部のキャラ)" },
	{ value: 1.4, label: "1.4 (通常産/イベント産・気力12)" },
] as const;

export const ACTIVE_SKILL_POWER_OPTIONS = [
	{ value: 5.5, label: "「究極ダメージを与える」" },
	{ value: 1.0, label: "「ダメージを与える」" },
] as const;

export const DEFAULT_DOKKAN_STATS: DokkanStats = {
	// 基礎ステータス
	stats_atk: 0,
	stats_def: 0,

	// リーダースキル (default 220%)
	Lskill_atk_1: 220,
	Lskill_def_1: 220,
	Lskill_atk_2: 220,
	Lskill_def_2: 220,

	// パッシブスキル
	Pskill_atk_1: 0,
	Pskill_def_1: 0,
	Pskill_atk_2: 0,
	Pskill_def_2: 0,

	// サポート効果
	support_atk_1: 0,
	support_def_1: 0,
	support_atk_2: 0,
	support_def_2: 0,
	support_atk_active: 0,
	support_def_active: 0,
	support_atk_field: 0,
	support_def_field: 0,
	support_atk_memory: 0,
	support_def_memory: 0,
	support_atk_item: 0,
	support_def_item: 0,

	// 必殺技
	SA_atk: 0,
	SA_def: 0,
	SA_power: 5.7,
	SAboost_level: 6,

	// その他
	link_atk: 0,
	link_def: 0,
	ki_bonus: 2.0,
};
